<div class="error" *ngIf="errorMessage !== null">{{ errorMessage }}</div>
